import { createAction, union, props } from '@ngrx/store';

import { FlightBasket } from '../../interfaces/upgrades.interface';

export const addPaxToBasket = createAction('[Basket] Add passenger', props<{ passengerId: string }>());
export const addFlightToBasket = createAction('[Basket] Add flight', props<{ flight: FlightBasket }>());

export const removeFlight = createAction('[Basket] Remove flight', props<{ flightId: string }>());
export const removePassenger = createAction('[Basket] Remove Passenger', props<{ passengerId: string }>());

export const updateFlight = createAction('[Basket] Update flight', props<{ flight: FlightBasket }>());

export const clearBasket = createAction('[Basket] Clear');
export const clearFlights = createAction('[Basket] Clear flight');
export const clearPassengers = createAction('[Basket] Clear Passengers');

const all = union({
  addPaxToBasket,
  addFlightToBasket,
  removeFlight,
  removePassenger,
  updateFlight,
  clearBasket,
  clearFlights,
  clearPassengers,
});
export type BasketActionsUnion = typeof all;
